export default __webpack_public_path__ + "static/media/flow-explanation2-4x.aee8766c.png";